import { memo, useMemo } from 'react';

import { Bin } from 'app/modules/inventory/bins/core/type';

import { formatDate } from 'app/helpers';

const ExpiryContent = ({ expiries }: { expiries: Bin['expiry'] }) => {
  const listItems = useMemo(
    () =>
      expiries.reduce<React.ReactNode[]>((acc, expiry) => {
        if (expiry.qty > 0) {
          acc.push(
            <li key={`${expiry.batchId}`}>
              Batch {expiry.lotNumber ? expiry.lotNumber : expiry.stockRunIndex} – {expiry.qty}{' '}
              unit(s), expires on {formatDate(expiry.expiryDate)}.
            </li>,
          );
        }
        return acc;
      }, []),
    [expiries],
  );

  return <ul>{listItems}</ul>;
};

export default memo(ExpiryContent);
